<template>
  <div>
    <project-one-bike-image />
  </div>
</template>

<script>
import ProjectOneBikeImage from '@/projectOne/components/shared/ProjectOneBikeImage';

export default {
  components: {ProjectOneBikeImage},
};
</script>
